import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { RecordingNavigationGuardProvider } from './context/RecordingNavigationGuard';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './store';
import { AlertProvider } from './alert/AlertContext.js';
import AlertPopup from './alert/AlertPopup.js';
import { WalletBalanceProvider } from './creditWallet/WalletBalanceContext.js';
import "react-big-calendar/lib/css/react-big-calendar.css";
import { init as initAnalytics } from './analytics';
import { createAnalyticsConfig } from './analytics/config';
// Side-effect import: axios interceptor that signs RAG-backend requests.
import './utils/ragAxiosAuth.js';
import packageJson from '../package.json';

initAnalytics(createAnalyticsConfig({
  env: process.env,
  appVersion: packageJson.version,
  getState: store.getState,
  getPagePath: () => window.location.pathname,
  storage: localStorage,
}));

// Prevent ResizeObserver loop limit exceeded / completed with undelivered notifications errors from crashing/showing overlay in development
window.onerror = function (message, source, lineno, colno, error) {
  if (
    message &&
    (message.toString().includes('ResizeObserver') ||
      message.toString().includes('Resize observer') ||
      message.toString().includes('loop completed with undelivered notifications'))
  ) {
    console.warn('Suppressed benign ResizeObserver warning:', message);
    return true; // Completely intercepts and prevents the React error overlay!
  }
};

const preventResizeObserverError = (e) => {
  if (
    e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded' ||
    e.message?.includes('ResizeObserver')
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
};

window.addEventListener('error', preventResizeObserverError, true);
window.addEventListener('unhandledrejection', (e) => {
  if (
    e.reason?.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.reason?.message === 'ResizeObserver loop limit exceeded' ||
    e.reason?.message?.includes('ResizeObserver')
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const theme = createTheme({
  typography: {
    fontFamily: 'Inter, sans-serif',
    allVariants: {
      color: '#000000',
    },
  },
  palette: {
    text: {
      primary: '#000000',
    },
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "#29C0BB",
          '&:hover': {
            backgroundColor: 'transparent',
          }
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
              border: `2px solid #29C0BB`,
            },
          }
        }
      }
    },
    // MuiTextField: {
    //   styleOverrides: {
    //     root: {
    //       "& .MuiInputBase-input.Mui-disabled": {
    //         WebkitTextFillColor: "#000000",
    //       },
    //     },
    //   },
    // }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <AlertProvider>
            <WalletBalanceProvider>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <AlertPopup />
                <RecordingNavigationGuardProvider><App /></RecordingNavigationGuardProvider>
              </ThemeProvider>
            </WalletBalanceProvider>
          </AlertProvider>
        </Router>
      </PersistGate>
    </Provider>
);
